// extracted by mini-css-extract-plugin
export var drawerContent = "_2m-0";
export var valueBlock = "_2m-1";
export var valueBlockFrom = "_2m-2 _2m-1";
export var valueBlockTo = "_2m-3 _2m-1";